// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"ea14daff","87":"b5efeeac","181":"60003318","428":"2649d279","453":"7614b196","504":"78d20c11","750":"677cf362","852":"0623762f","971":"c25f3dd5"}[chunkId] + ".chunk.js";
};